import {
    createCombinedReducer,
    createModuleFactory,
    IModuleFactory,
} from '@omaze/redux';
import { Reducer } from 'redux';

import { createHideModalReducer } from './actions/HideModal/HideModal';
import { createModalShowReducer } from './actions/ShowModal/ShowModal';
import { IModalState, MODAL_NAMESPACE } from './Modal.state';

const initialState: IModalState = {
    modalComponent: null,
    onOpenFunction: null,
    onCloseFunction: null,
    hideMask: false,
};

const modalReducer: Reducer<IModalState> = createCombinedReducer<IModalState>([
    createModalShowReducer,
    createHideModalReducer,
], initialState);

export const getModalModule: IModuleFactory = createModuleFactory<IModalState>(MODAL_NAMESPACE, modalReducer);
